var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightThinS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2906 12.0159L6.39326 4.11852C6.13715 3.86241 6.00613 3.57913 6.00019 3.26868C5.99426 2.95854 6.12528 2.66963 6.39326 2.40197C6.66092 2.13399 6.94702 2 7.25154 2C7.55575 2 7.84699 2.13914 8.12528 2.41743L16.6931 10.9852C16.8352 11.1398 16.9418 11.3022 17.0131 11.4725C17.0843 11.6427 17.1199 11.8269 17.1199 12.0253C17.1199 12.2233 17.0843 12.4074 17.0131 12.5776C16.9418 12.7482 16.8352 12.9045 16.6931 13.0466L8.12528 21.6144C7.85886 21.8808 7.57823 22.0092 7.28339 21.9995C6.98856 21.9901 6.70715 21.8516 6.43917 21.5839C6.17151 21.3163 6.03767 21.0302 6.03767 20.7257C6.03767 20.4211 6.17151 20.135 6.43917 19.8674L14.2906 12.0159Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightThinS);
export default __webpack_public_path__ + "static/media/arrow-right-thin-s.5a153109145a757be48b52611443d33a.svg";
export { ForwardRef as ReactComponent };